import { ReactNode } from 'react';

import { CarInfoBaseProps } from './types';
import { CarInfoCardBase } from './CarInfoCard.Base';

type CarInfoCardMobileProps = {
  base: CarInfoBaseProps;
  infoSlot?: ReactNode;
  bannerSlot?: ReactNode;
  className?: string;
};

export const CarInfoCardMobile = ({
  base,
  infoSlot,
  bannerSlot,
  className,
}: CarInfoCardMobileProps) => {
  return (
    <CarInfoCardBase
      base={base}
      infoSlot={infoSlot}
      bannerSlot={bannerSlot}
      className={className}
      layout="column"
    />
  );
};
